import React from "react";
import i18n from "../../../../i18n/i18n";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import {storesContext} from "../../../../common/stores/stores";
import {ITimetableStore} from "../../../stores/timetableStore";
import DateAndTime from "../dateAndTime/dateAndTime";
import DropDown from "../../../../common/components/shared/dropDown/dropDown";
import {DropDownModel} from "../../../../common/models/dropDown";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {Api} from "../../../../helpers/api";

interface ArrivalActionSectionProps {
    actionIndex: number;
    wharfs: DropDownModel[];
    whrafsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    reloadFunc: () => void;
}

export default class ArrivalActionSection extends React.Component <ArrivalActionSectionProps> {
    static contextType = storesContext;

    render() {
        const timetableStore = this.context.timetableStore as ITimetableStore;

        return (
            <>
                <div className="section with-border">
                    <TextInput
                        label={i18n.t("timetable.headers.voyageNo")}
                        validatedValue={timetableStore.actions[this.props.actionIndex].voyageNo}
                        testId={`voyage-no-${this.props.actionIndex}`}
                        className="voyageNo"
                        disabled={timetableStore.actions[this.props.actionIndex].hasOrderRegistered}
                    />
                    <DropDown
                        label={i18n.t("timetable.headers.wharf")}
                        validatedValue={timetableStore.actions[this.props.actionIndex].wharfId}
                        items={this.props.wharfs}
                        testId={`wharf-${this.props.actionIndex}`}
                        withoutSort
                        error={!Api.isSuccess(this.props.whrafsResponse) ? i18n.t("errorMessages.whrafsErrorSuffix") : ""}
                        reloadFunc={() => this.props.reloadFunc()}
                    />
                    <TextInput
                        label={i18n.t("timetable.headers.notes")}
                        validatedValue={timetableStore.actions[this.props.actionIndex].notes}
                        testId={`notes-${this.props.actionIndex}`}
                        className="notes"
                        maxLength={150}
                    />
                </div>
                <div className="section">
                    <div className="time-section">
                        <div>
                            <div className="time-header">{i18n.t("timetable.headers.plannedTime")}</div>
                            <DateAndTime
                                testId={`arrival-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.arrivalTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].arrivalDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setArrivalDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].arrivalHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setArrivalHour(newDate);
                                }}
                                disabled={timetableStore.actions[this.props.actionIndex].hasOrderRegistered}
                            />
                            <DateAndTime
                                testId={`departure-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.departureTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].departureDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setDepartureDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].departureHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setDepartureHour(newDate);
                                }}
                                disabled={timetableStore.actions[this.props.actionIndex].hasOrderRegistered}
                            />

                        </div>
                        <div>
                            <div className="time-header">{i18n.t("timetable.headers.actualTime")}</div>
                            <DateAndTime
                                testId={`actual-arrival-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.actualArrivalTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].actualArrivalDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setActualArrivalDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].actualArrivalHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setActualArrivalHour(newDate);
                                }}
                            />

                            <DateAndTime
                                testId={`actual-departure-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.actualDepartureTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].actualDepartureDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setActualDepartureDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].actualDepartureHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setActualDepartureHour(newDate);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
